<template>
  <div>
    <iModal
      v-model="showModal"
      class-name="msg-release"
      width="900px"
      :mask-closable="false"
      :footer-hide="true"
      @on-cancel="$emit('close')"
      :styles="{top: '50px'}"
    >
      <div class="msg-modal">
        <div class="msg-modal-title">留言管理</div>
        <div class="msg-modal-content">
          <!-- .msg-modal-content  mmc -->
          <div class="mmc" v-if="commentList && commentList.items">
            <div
              class="mmc-item"
              v-for="(item, index) in commentList.items"
              :key="'commentList-'+index"
            >
              <div class="mmc-item-l">{{item.userInfo.NickName}}：</div>
              <div class="mmc-item-c">
                <div
                  class="mmc-item-c-info"
                  :style="{'padding-right': item.active ? '78px' : '0'}"
                >{{item.msgInfo}}</div>
                <div v-if="item.active" class="mmc-item-c-box">
                  <Input
                    v-model="value"
                    type="textarea"
                    placeholder="请输入留言内容"
                    class="mmc-item-c-inp"
                  />
                  <div class="mmc-btn" @click="send(item)">发送</div>
                </div>
                <div
                  class="mmc-item-sub"
                  v-if="item.children && item.children.items &&item.children.items.length"
                  :style="{'margin-right': item.active ? '78px' : '0'}"
                >
                  <div
                    class="mmc-item-sub-list"
                    v-for="(sub, index) in item.children.items"
                    :key="'subcomment' + index"
                  >
                    <span class="s-blue">回复</span>
                    {{item.userInfo.NickName}}：{{sub.msgInfo}}
                  </div>
                </div>
              </div>
              <div class="mmc-item-r" v-if="!item.active">
                <div class="mmc-tool">
                  <Poptip confirm title="确认是否删除？" @on-ok="delItem(item)" @on-cancel="cancel">
                    <span style="color: #f00;">删除</span>
                  </Poptip>
                  <span class="mmc-tool-line"></span>
                  <span style="color: #1890ff;" @click="setActive(index)">回复</span>
                </div>
              </div>
            </div>
          </div>
          <div class="u-empty" v-else>暂无数据</div>
        </div>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
export default {
  name: "msg-release",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      value: "",
      showModal: false,
      chanceList: [], //商机列表
      msgShow: false,
      editInp: "", // 留言内容
      commentList: [],

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    info(val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      user: "getUser"
    }),
    option() {
      return {
        By: this.info.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {},
  methods: {
    ...mapActions({
      getReleaseComment: "releaseModule/getReleaseComment",
      delReleaseComment: "releaseModule/delReleaseComment",
      sendReleaseComment: "releaseModule/sendReleaseComment"
    }),
    init() {
      // 初始化数据；
      this.getChanceList();
    },
    async getChanceList() {
      let data = await this.getReleaseComment(this.option);
      if (data && data.items.length) {
        data.items.map(c => {
          c.active = false;
          c.releaseInfo = c.releaseInfo
            ? JSON.parse(c.releaseInfo)
            : c.releaseInfo;
          c.userInfo = c.userInfo ? JSON.parse(c.userInfo) : c.userInfo;
          if (c.children && c.children.items) {
            c.children.items.map(v => {
              v.releaseInfo = v.releaseInfo
                ? JSON.parse(v.releaseInfo)
                : v.releaseInfo;
              v.userInfo = v.userInfo ? JSON.parse(v.userInfo) : v.userInfo;
            });
          }
        });
        this.commentList = data;
        if (this.commentList.items) {
          this.pageSize = this.commentList.pageSize;
          this.pageIndex = this.commentList.pageIndex;
          this.totalCount = this.commentList.totalCount;
        }
      } else {
        this.commentList = [];
      }
    },
    close() {
      this.loading = false;
      this.value = "";
      this.$emit("close");
    },
    async delItem(item) {
      let result = await this.delReleaseComment(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
        // this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    cancel() {},
    async send(item) {
      if (!this.value) {
        this.$Message.error("回复内容不能为空！");
        return;
      }
      let req = {
        ParentId: item.id,
        ReleaseId: item.releaseId,
        UserId: this.user.id,
        MsgInfo: this.value
      };
      let result = await this.sendReleaseComment(req);
      if (result.successed) {
        this.$Message.success("回复成功");
        this.init();
      } else {
        this.$Message.error("回复失败，请重新尝试");
      }
      this.value = "";
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    setActive(index) {
      this.commentList.items.map((c, i) => {
        if (i === index) {
          c.active = true;
        } else {
          c.active = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-modal {
  border-radius: 5px;
  height: 650px;
  &-title {
    padding: 23px 41px 15px;
    background: #fff;
    font-size: 18px;
    color: #333;
    border-radius: 5px;
  }
  &-content {
    background: #f2f2f2;
    height: 500px;
    overflow: auto;
    .mmc {
      &-item {
        padding: 19px 30px;
        border-bottom: 1px solid #bfbfbf;
        font-size: 14px;
        color: #4d4d4d;
        display: flex;
        flex-wrap: wrap;
        &-l {
          min-width: 76px;
          text-align: right;
        }
        &-c {
          font-size: 14px;
          color: #333;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          &-info {
            width: 100%;
            text-align: justify;
          }
          &-box {
            width: 100%;
            padding-top: 15px;
            display: flex;
            flex-wrap: wrap;
          }
          &-inp {
            flex: 1;
            margin-right: 20px;
            cursor: pointer;
          }
        }
        &-r {
          width: 82px;
          font-size: 14px;
          color: #333;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        &-sub {
          background: #fff;
          padding: 8px 13px;
          width: 100%;
          margin-top: 20px;
          .s-blue {
            color: #1890ff;
          }
          &-list {
            color: #333;
          }
        }
      }
      &-btn {
        width: 58px;
        line-height: 50px;
        border-radius: 4px;
        border: solid 1px #1890ff;
        color: #1890ff;
        text-align: center;
      }
      &-tool {
        display: flex;
        &-line {
          width: 1px;
          height: 21px;
          background-color: #e8e8e8;
          display: inline-block;
          margin: 0 7px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.msg-release {
  .ivu-modal-body {
    padding: 0;
  }
}
.my-page {
  padding: 25px;
}
</style>